import { adminRecords } from "./adminRecords";
import React, { useEffect, useState } from "react";
import Utils, { SOURCES } from "./../Utils";
import Card from "../models/Card";
import Select from "react-select";

import { Link } from "react-router-dom";
import update from "react-addons-update";
var dateFormat = require("dateformat");

const FILTER_SOURCES = SOURCES.sort().map((source) => {
  return { value: source, label: source };
});

function DislikedCards(props) {
  //const [favs, setFavs] = useState([]);
  const [results, setResults] = useState([]);
  const [events, setEvents] = useState([]);
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setPage] = useState(1);
  const [source, setSource] = useState(null);

  async function query(page, clear = false) {
    const ref = adminRecords.collection("events").where("eventType", "in", ["dislike"]);
    let query;
    let set = {};

    if (queries[page] && !clear) {
      query = queries[page];
    } else {
      query = ref.limit(25).orderBy("createdAt", "desc");

      if (source) {
        query = query.where("source", "==", source.value);
      }

      if (page != 1) {
        // look at previous page to build next query
        let result = results[page - 1];

        if (result) {
          query = query.startAfter(result[result.length - 1]);
        } else {
          console.log("Cannot construct a query for a page that is not adjacent to one already fetched");
        }
      }

      setQueries(update(queries, { [page]: { $set: query } }));
    }

    if (props.user) {
      query = query.where("userId", "==", props.user.uid);
    }

    let querySnapshot = await query.get();

    set.completions = querySnapshot.docs;

    await props.userCache.fetchIds(
      querySnapshot.docs.map((doc) => {
        return doc.get("userId");
      })
    );

    setEvents(querySnapshot.docs);
    setResults(update(results, { [page]: { $set: querySnapshot.docs } }));
    setLoading(false);
  }

  useEffect(() => {
    query(currentPage);
  }, [currentPage]);

  useEffect(() => {
    setQueries([]);
    query(currentPage, true);
  }, [source]);

  let cards = events.map((event) => {
    let data = event.get("card");
    let card = new Card(event.get("cardId"), data);

    return {
      card: card,
      event: event,
    };
  });

  return (
    <div id="disliked-cards">
      Filter by source:
      <br />
      <br />
      <Select
        className={"select"}
        value={source}
        onChange={(selectedOption) => {
          setSource(selectedOption);
        }}
        options={FILTER_SOURCES}
      />
      <br />
      {cards.map((card) => {
        let user = props.userCache.getUser(card.card.data.userId);
        return (
          <CardView
            card={card.card}
            event={card.event}
            user={user}
            key={card.card.id}
          />
        );
      })}
      <button
        onClick={(e) => {
          e.preventDefault();
          setPage(currentPage + 1);
        }}
      >
        Next Page &rarr;
      </button>
    </div>
  );
}

function CardView(props) {
  const [truncatePrompt, setTruncatePrompt] = useState(true);

  let card = props.card;

  const truncateLength = 500;
  let needsTruncation = false;
  let collapsedPrompt = card.prompt;
  let prompt = card.prompt;

  if (prompt.length > truncateLength) {
    needsTruncation = true;

    collapsedPrompt = collapsedPrompt.slice(prompt.length - truncateLength, prompt.length);
    collapsedPrompt = "... " + collapsedPrompt;

    if (truncatePrompt) {
      prompt = prompt.slice(prompt.length - truncateLength, prompt.length);
      prompt = "... " + prompt;
    }
  }

  if (card.data.passage) {
    prompt = `Object to Describe: ${prompt}\n\n${card.data.passage}`;
  }

  let path = props.event.get("path");
  let content = props.card.contentFromPath(props.event.get("path"));

  // for (const [key, value] of Object.entries(card.data.content)) {
  //   if (typeof value === "string") {
  //     let highlight = path[1] === i;

  //     out.push(<div className={classnames({ card: true, highlight: highlight })}>
  //       <h4>{i+1}</h4>
  //       <div>{Utils.nl2br(value)}</div>
  //     </div>);
  //   } else {

  //     let highlight = path[0] === key;

  //     // it's an object with headings
  //     out.push(<div className={classnames({ card: true, highlight: highlight })}>
  //       <h4>{key}</h4>
  //       <div>{Utils.nl2br(value.join("\n\n"))}</div>
  //     </div>);
  //   }

  //   i += 1;
  // }
  console.log(card.data.createdAt);

  return (
    <div className="card">
      <div className="meta">
        <p>
          From: <Link to={`/admin/user/${props.user.email}`}>{props.user.email}</Link>
        </p>
        <p>Created: {dateFormat(card.data.createdAt, "mm/dd hh:MM")}</p>
      </div>
      <h2>{card.source}</h2>

      <div className="prompt">
        {needsTruncation && truncatePrompt && (
          <a
            onClick={(e) => {
              setTruncatePrompt(false);
            }}
          >
            (Show whole prompt)
          </a>
        )}
        {Utils.nl2br(prompt)}
      </div>

      <div className="content">
        <h3>{path[0] ? path[0] : "Choice " + (path[1] + 1)}</h3>
        <div>{typeof content === "string" ? Utils.nl2br(content) : Utils.nl2br(content.text)}</div>
      </div>
    </div>
  );
}

export default DislikedCards;
